import React from 'react';
import EmptyDataIcon from "../../../../assets/cms-icon-empty-files.svg";
import { messages } from '../../../../utils/language-en.json';
import EmptyData from '../../../Common/emptydata/emptyData';
import RaisePayRateCard from './RaisePayRateCard';

function RaisePayRateList({ positions }) {
  return (
    <div className="RaisePayRateList">
      <div className="row">
        { positions.length === 0
            ? <EmptyData
              type={"datatable"}
              icon={EmptyDataIcon}
              title={messages.emptydata.tableTitle}
              messsage={messages.emptydata.tableCopy}
            />
            : positions.map( (item, idx) => (
                <div className="col-sm-3" key={idx}>
                  <RaisePayRateCard item={item} />
                </div>
              ) )
        }
      </div>
    </div>
  )
}

export default RaisePayRateList
